import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const fraudulantEmailPlugin = createPlugin({
  id: 'fraudulant-email',
  routes: {
    root: rootRouteRef,
  },
  externalRoutes: {},
});

export const FraudulantEmailPage = fraudulantEmailPlugin.provide(
  createRoutableExtension({
    name: 'FraudulantEmailPage',
    component: () =>
      import('./components/OptimizedFraudulentEmail').then(
        m => m.OptimizedFraudulentEmail,
      ),
    mountPoint: rootRouteRef,
  }),
);
